var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement_wrap",domProps:{"innerHTML":_vm._s(_vm.agreement)}})
}
var staticRenderFns = []

export { render, staticRenderFns }